import { render, staticRenderFns } from "./OP_ByPatientType.vue?vue&type=template&id=93f42422&scoped=true&"
import script from "./OP_ByPatientType.vue?vue&type=script&lang=js&"
export * from "./OP_ByPatientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f42422",
  null
  
)

export default component.exports